module.exports = "<div class=\"content\">\n\n  <div class=\"loading\">\n    <div class=\"loading-message\" *ngIf=\"!tagLoaded\">Processing tour tag...</div>\n    <i class=\"fa fa-spinner fa-spin font-spinner orange\" *ngIf=\"!tagLoaded\"></i>\n    <div><img src=\"./assets/gotour-logo-large.png\" class=\"home-logo\"/></div>\n    <button type=\"button\" class=\"primary-button\" (click)=\"showTourForTag()\" *ngIf=\"tagLoaded\"><i class=\"fa fa-home\" aria-hidden=\"true\"></i>View Full Tour</button>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tag.component.html
// module id = ./src/app/components/tag.component.html
// module chunks = main